import React, { useEffect } from 'react';
import DefaultLayout from '../layouts/DefaultLayout';
import { fetchWithAuth } from '../services/Fetch';

const Logout: React.FC = () => {

    const logout = async () => {
        const response = await fetchWithAuth('/logout', {method: "POST"});
        if (!response.ok) {
            throw new Error('Network response was not ok');
        } else {
            document.location.href = '/login';
        }
    }

    useEffect(() => { logout() }, []);

    return (
        <DefaultLayout>
            <p>Déconnexion...</p>
        </DefaultLayout>
    );
}

export default Logout;